import { render, staticRenderFns } from "./NewsCreate.vue?vue&type=template&id=4aed7508&scoped=true&"
import script from "./NewsCreate.vue?vue&type=script&lang=js&"
export * from "./NewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./NewsCreate.vue?vue&type=style&index=0&id=4aed7508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed7508",
  null
  
)

export default component.exports